import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import About from './views/About.vue'
import index from './views/index/index.vue'
import packageChoice from './views/package/packageChoice.vue'
import userInfo from './views/user/userInfo.vue'
import numberList from './views/numberList/numberList.vue'
import orderFlow from './views/order/orderFlow.vue'
import needPayInfo from './views/pay/needPayInfo.vue'
import checkPayResult from './views/pay/checkPayResult.vue'
import orderList from './views/order/orderList.vue'
import index170 from './views/170/index170.vue'
import ctc5g from './views/ctc5g/ctc5g.vue'
import ctcNeedPayInfo from './views/ctc5g/ctcNeedPayInfo.vue'
import creditCardContractFile1 from './views/crmapp/creditCardContractFile1.vue'
import creditCardContractFile2 from './views/crmapp/creditCardContractFile2.vue'
import barImage from './views/crmapp/barImage.vue'
import downMstxApp from './views/crmapp/downMstxApp.vue'
import xmhb from './views/crmapp/xiaominhuibao.vue'

import networkAccessProtocol from './views/common/networkAccessProtocol.vue'
import insuranceAccessProtocol from './views/common/insuranceAccessProtocol.vue'

import queryNumber from './views/psptIdNumber/queryNumber.vue'
import secondRealName from './views/secondRealName/secondRealName.vue'
import aIdx from './views/thirdActivity/index.vue'
import aNl from './views/thirdActivity/numberList.vue'
import aOf from './views/thirdActivity/orderFlow.vue'
import aOl from './views/thirdActivity/orderList.vue'
import aSo from './views/thirdActivity/saveOrder.vue'
import aPc from './views/thirdActivity/packageChoice.vue'
import pIdx from './views/thirdActivity/processIndex.vue'


Vue.use(Router)

export default new Router({
  mode: 'history',
  base: 'choiceNumber',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      children:[
        {path: '/about', name:'about', component: About},
        {path: '/index', name:'index', component: index},
        {path: '/packageChoice', name:'packageChoice', component: packageChoice},
        {path: '/userInfo', name:'userInfo', component: userInfo},
        {path: '/numberList', name:'numberList', component: numberList},
        {path: '/orderFlow', name:'orderFlow', component: orderFlow},
        {path: '/needPayInfo', name:'needPayInfo', component: needPayInfo},
        {path: '/orderList', name:'orderList', component: orderList},
        {path: '/checkPayResult', name:'checkPayResult', component: checkPayResult},
        {path: '/ctc5g/:cl', name:'ctc5g', component: ctc5g},
        {path: '/ctcNeedPayInfo', name:'ctcNeedPayInfo', component: ctcNeedPayInfo},
        {path: '/more170', name:'index170', component: index170},
        {path: '/more170Index', name:'index170', component: index170},
        {path: '/creditCardContractFile1', name:'creditCardContractFile1', component: creditCardContractFile1},
        {path: '/creditCardContractFile2', name:'creditCardContractFile2', component: creditCardContractFile2},
        {path: '/barImage', name:'barImage', component: barImage},
        {path: '/downMstxApp', name:'downMstxApp', component: downMstxApp},
        {path: '/networkAccessProtocol', name:'networkAccessProtocol', component: networkAccessProtocol},
        {path: '/insuranceAccessProtocol', name:'insuranceAccessProtocol', component: insuranceAccessProtocol},
        // {path: '/queryNumber', name:'queryNumber', component: queryNumber},
        {path: '/secondRealName', name:'secondRealName', component: secondRealName},
        {path: '/aIdx', name:'aIdx', component: aIdx},
        {path: '/aNl', name:'aNl', component: aNl},
        {path: '/aOf', name:'aOf', component: aOf},
        {path: '/aOl', name:'aOl', component: aOl},
        {path: '/aSo', name:'aSo', component: aSo},
        {path: '/aPc', name:'aPc', component: aPc},
        {path: '/pIdx', name:'pIdx', component: pIdx},
        {path: '/xmhb', name:'xmhb', component: xmhb}

      ]
    },
    {
      path: '/',
      name: '',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    }
  ]
})
